<template>
  <div class="studyApply" v-if="load">
    <div class="banner">
      <img :src="banner.cover" alt />
    </div>
    <div class="row job-content">
      <div class="column small-12 medium-5 large-4">
        <h3>学习实践申请</h3>
        <div style="margin-bottom: 1.4rem; padding-top: 1.4rem">
          <h4>一起学习实践</h4>
          <p>系统性地学习宏观、行业、公司研究思路，或者了解金融科技如何实现与交易的完美结合</p>
          <p>创建属于自己的策略并见证成长</p>
        </div>
      </div>
      <div class="column samll-12 medium-7 large-8">
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item ref="name" label="姓名" prop="name">
            <a-input
              v-model="form.name"
              @blur="
          () => {
            $refs.name.onFieldBlur();
          }
        "
            />
          </a-form-model-item>
          <a-form-model-item label="性别" prop="sex">
            <a-radio-group v-model="form.resource">
              <a-radio value="1">男</a-radio>
              <a-radio value="2">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="出生年月" prop="date">
            <a-date-picker
              v-model="form.date"
              type="date"
              :format="dateFormat"
              placeholder="请选择出生年月"
              style="width: 100%;"
            />
          </a-form-model-item>
          <a-form-model-item label="联系电话" prop="tel">
            <a-input v-model="form.tel" />
          </a-form-model-item>
          <a-form-model-item label="邮箱" prop="email">
            <a-input v-model="form.email" />
          </a-form-model-item>
          <a-form-model-item label="所在院校" prop="school">
            <a-input v-model="form.school" />
          </a-form-model-item>
          <a-form-model-item label="所学专业" prop="major">
            <a-input v-model="form.major" />
          </a-form-model-item>
          <a-form-model-item label="毕业时间" prop="date1">
            <a-date-picker
              v-model="form.date1"
              :format="dateFormat"
              type="date"
              placeholder="请选择毕业时间"
              style="width: 100%;"
            />
          </a-form-model-item>
          <a-form-model-item label="个人简介" prop="brief">
            <a-input v-model="form.brief" type="textarea" :auto-size="{ minRows: 3, maxRows: 5 }" />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
            <div class="row">
              <div class="column small-12 medium-12 large-12 action-btn">
                <div class="button" @click="resetForm">
                  <a href="javascript:;">重置</a>
                </div>
                <div class="button">
                  <a href="javascript:;" @click="onSubmit">提交</a>
                </div>
              </div>
            </div>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </div>
</template>

<script>
import { StudyApply, StudyApplyBanner } from "@/api/index";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      load: false,
      banner: null,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      dateFormat: "YYYY/MM/DD",
      form: {
        name: "",
        sex: undefined,
        date: undefined,
        tel: "",
        email: "",
        school: "",
        major: "",
        date1: "",
        brief: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        tel: [
          {
            required: true,
            message: "请输入电话",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur",
          },
        ],
        brief: [
          {
            required: true,
            message: "请输入个人简介",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          StudyApply(
            {
              username: this.form.name,
              sex: this.form.sex,
              birthday: moment(this.form.date).format("YYYY-MM-DD"),
              tel: this.form.tel,
              email: this.form.email,
              school: this.form.school,
              profession: this.form.major,
              graduate_time: moment(this.form.date1).format("YYYY-MM-DD"),
              brief: this.form.brief,
            },
            (res) => {
              if (res.code == 0 && res.data === true) {
                this.$message.success("提交成功");
              } else {
                this.$message.error("提交失败");
              }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
  created() {
    StudyApplyBanner((res) => {
      this.load = true;
      this.$emit("complete", true);
      if (res.code == 0) {
        this.banner = res.data.banner;
      }
    });
  },
  mounted() {},
};
</script>
<style lang="less">
.ant-radio-checked .ant-radio-inner {
  border-color: #e77500 !important;
}
.ant-radio-checked::after {
  border: 1px solid #e77500 !important;
}
.ant-radio-inner::after {
  background-color: #e77500 !important;
}
@media print, screen and (max-width: 40em) {
  .action-btn {
    .button {
      margin: 0 1rem !important;
    }
  }
  .ant-form-item-label {
    width: 100%;
  }
  .ant-form-item-control-wrapper {
    width: 100%;
  }
  .ant-col-offset-4 {
    margin-left: 0;
  }
}
</style>
<style lang='less' scoped>
.action-btn {
  text-align: center;
  .button {
    margin: 0 2rem;
  }
}
.studyApply {
  input {
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  [type="date"] {
    border: none;
  }
}
.banner {
  width: 100%;
  img {
    width: 100%;
    height: 43vw;
  }
}
.job-content {
  padding: 1rem 0.6rem;
  h3 {
    width: fit-content;
    margin-bottom: 1rem;
    border-bottom: 4px solid #e77500;
  }
  h4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  p {
    margin-bottom: 0.4rem;
  }
}

@media print, screen and (min-width: 40em) {
  .job-content {
    padding: 2rem 0.75rem;
  }
}
@media print, screen and (min-width: 64.0625em) {
  .job-content {
    padding: 3rem 1.75rem;
  }
}
@media screen and (min-width: 80em) {
  .job-content {
    padding: 4rem 3.125rem;
  }
}
</style>